import Vue from 'vue'

const VueBus = {

	install(Vue) {
		Vue.prototype.$bus = new Vue()
	}

}

Vue.use(VueBus)

export default VueBus



// WEBPACK FOOTER //
// ./src/initializers/bus.js